import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import * as interceptors from './router/interceptors'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/pt-br'
import locale from 'element-ui/lib/locale'
import {DataTables, DataTablesServer} from 'vue-data-tables'
import VueNumeric from 'vue-numeric'

Vue.use(VueNumeric)
import Echo from "laravel-echo"
import Pusher from "pusher-js"
import * as types from './store/mutation-types'

import Acl from 'vue2-acl-ext'
import CripLoading from "crip-vue-loading"

import VueHighcharts from 'vue-highcharts';
import Highcharts from 'highcharts';
import loadExporting from 'highcharts/modules/exporting';


loadExporting(Highcharts);

Vue.use(VueHighcharts, { Highcharts });

locale.use(lang)
Vue.use(BootstrapVue)
Vue.use(ElementUI)
Vue.use(DataTables)
Vue.use(DataTablesServer)
Vue.use(VueHighcharts)
Vue.use(VueNumeric)

window.VERSION = '0.1.7'

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.PUSHER_APP_KEY,
  cluster: 'us2',
  encrypted: true
});

window._ = require('lodash')
window.collect = require('collect.js')
window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios.defaults.baseURL = process.env.API_URI
window.localforage = require('localforage')

window.axios.interceptors.request.use(interceptors.REQUEST_SUCCESS, interceptors.REQUEST_ERROR)
window.axios.interceptors.response.use(response => response, interceptors.RESPONSE_ERROR);

Vue.use(Acl, {router, store, init: 'public', fail: '/error'})
Vue.use(CripLoading, {axios})

Vue.prototype.$bus = new Vue();

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  },
  mounted() {
    window.Echo.channel("book").listen(".competencia-opened-change", e => {
      store.commit(types.SET_COMPETENCIA_OPEN, {competenciaOpen: e.competencia})
    });
  }
})



// WEBPACK FOOTER //
// ./src/main.js